import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import { ActivitiesFiltersParams } from '@recruitee/http-types';

import { NotificationCounterFilteredStore } from '../../types';

@Injectable({ providedIn: 'root' })
export class NotificationsCounterFilteredHttpService {
  constructor(protected httpApi: HttpApiService) {}

  public fetch(filters: ActivitiesFiltersParams): Observable<NotificationCounterFilteredStore> {
    return this.httpApi.get('tracking/notifications/counters', { ...filters });
  }
}
